<template>
  <BaseContainer>
    <v-content slot="principal">
      <div class="main-container">
        <v-container>
          <TabletHero />

          <TabletPainsSection class="section" />

          <div id="recursos">
            <TabletBenefitsSection class="section" />
          </div>

          <div id="como-funciona">
            <TabletHowItWorksSection class="section" />
          </div>

          <TabletShowcaseSection class="section" />

          <!-- <div ref="demo" v-lazy-intersect="loadDemo" class="section">
            <component :is="DemoComponent" v-if="showDemo" />
          </div> -->

          <TabletReportsSection class="section" />

          <TabletUseCasesSection class="section" />

          <!-- <TabletRequirementsSection class="section" /> -->

          <!-- <TabletOfferSection class="section" /> -->

          <div id="depoimentos">
            <TestimonialsCarousel class="section" />
          </div>

          <div id="faq">
            <Faq class="section" :items="tabletFaq" />
          </div>

          <GuaranteeSection class="section" />

          <BrdeLabsAwardSection class="section" />
        </v-container>
      </div><!-- /.main-container -->

      <Footer />

      <v-btn
        v-if="!hideWhatsapp"
        id="whatsapp-button"
        fab
        x-large
        color="success"
        class="whatsapp-button"
        aria-label="Falar no WhatsApp"
        @click="onWhatsappClick"
      >
        <v-icon x-large>mdi-whatsapp</v-icon>
      </v-btn>
    </v-content>
  </BaseContainer>
</template>

<script>
  import BaseContainer from '@/components/BaseContainer.vue';
  import Footer from '@/components/Footer.vue';
  import TabletHero from '@/components/tablet/TabletHero.vue';
  import TabletPainsSection from '@/components/tablet/TabletPainsSection.vue';
  import TabletBenefitsSection from '@/components/tablet/TabletBenefitsSection.vue';
  import TabletHowItWorksSection from '@/components/tablet/TabletHowItWorksSection.vue';
  import TabletShowcaseSection from '@/components/tablet/TabletShowcaseSection.vue';
  import TabletReportsSection from '@/components/tablet/TabletReportsSection.vue';
  import TabletUseCasesSection from '@/components/tablet/TabletUseCasesSection.vue';
  // import TabletRequirementsSection from '@/components/tablet/TabletRequirementsSection.vue';
  // import TabletOfferSection from '@/components/tablet/TabletOfferSection.vue';
  import Faq from '@/components/Faq.vue';
  import TestimonialsCarousel from '@/components/TestimonialsCarousel.vue';
  import GuaranteeSection from '@/components/GuaranteeSection.vue';
  import BrdeLabsAwardSection from '@/components/BrdeLabsAwardSection.vue';
  import faqTablet from '@/seo/faq-tablet';
  import { mapState } from 'vuex';
  import scrollDepthMixin from '@/utils/useScrollDepth';
  import { trackClick } from '@/utils/lpTracker';

  export default {
    name: 'Tablet',

    mixins: [scrollDepthMixin],

    components: {
      BaseContainer,
      Footer,
      TabletHero,
      TabletPainsSection,
      TabletBenefitsSection,
      TabletHowItWorksSection,
      TabletShowcaseSection,
      TabletReportsSection,
      TabletUseCasesSection,
      // TabletRequirementsSection,
      // TabletOfferSection,
      Faq,
      TestimonialsCarousel,
      GuaranteeSection,
      BrdeLabsAwardSection,
    },

    data: () => ({
      showDemo: false,
      DemoComponent: null,
      // Dataset em src/seo/faq-tablet.js: o JSON-LD FAQPage da rota /tablet
      // lê do mesmo arquivo, para o dado estruturado nunca divergir da tela.
      tabletFaq: faqTablet,
    }),

    directives: {
      lazyIntersect: {
        inserted(el, binding) {
          const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
              binding.value();
              observer.unobserve(el);
            }
          });
          observer.observe(el);
        },
      },
    },

    computed: {
      ...mapState([
        'hideWhatsapp',
      ]),
    },

    mounted() {
      this.$root.$on('ctaButtonClick', this.goToWhatsappForm);
    },

    beforeDestroy() {
      this.$root.$off('ctaButtonClick', this.goToWhatsappForm);
    },

    methods: {
      // loadDemo() {
      //   this.showDemo = true;
      //   import('@/components/tablet/TabletDemoSection.vue').then(m => this.DemoComponent = m.default);
      // },

      goToWhatsappForm() {
        this.$router.push({
          path: '/whatsapp',
          query: { ...this.$route.query, produto: 'tablet' },
        });
      },

      onWhatsappClick() {
        trackClick('Tablet - WhatsApp floating button');
        this.goToWhatsappForm();
      },
    },
  };
</script>

<style scoped lang="scss">
  .main-container {
    margin: 12px 3% 0 3%;
  }

  .whatsapp-button {
    z-index: 999;
    position: fixed;
    bottom: 30px;
    right: 30px;
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  .section {
    margin-top: 72px;
    padding-top: 72px;
    border-top: 1px solid var(--card-border);

    @media (max-width: 780px) {
      margin-top: 48px;
      padding-top: 48px;
    }
  }
</style>
